import type { TargetScoreOption } from "@/lib/constant";
import { supabase } from "@/lib/supabaseClient";

type UserSettings = {
  target_score: TargetScoreOption;
};

/** 사용자 설정 조회 (없으면 null) */
export async function getUserSettings(userId: string): Promise<UserSettings | null> {
  const { data, error } = await supabase
    .from("user_settings")
    .select("target_score")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data as UserSettings | null;
}

/** 합격 기준 점수 upsert */
export async function upsertTargetScore(userId: string, targetScore: TargetScoreOption): Promise<void> {
  const { error } = await supabase
    .from("user_settings")
    .upsert({ user_id: userId, target_score: targetScore }, { onConflict: "user_id" });

  if (error) {
    throw error;
  }
}
